import { ISaveSubscriptionProps } from 'reactApp/components/VkBuyModalWithSidebar/SaveSubscriptionSidebar/SaveSubscriptionSidebar';
import { Tariff } from 'reactApp/types/Billing';

export interface IProps {
    productId: string;
    onClose: () => void;
    onSuccess?: () => void;
    type: EPaymentModalType;
    tariff?: Tariff;
    sidebarProps?: ISaveSubscriptionProps;
}

export enum EPaymentModalType {
    trial = 'trial',
    fastcheckout = 'fastcheckout',
    saveSubscription = 'saveSubscription',
}
